// Import all components here
// import React, { Component } from 'react'
import Dashboard from './HRMS/Dashboard/Dashboard';
import EmployeeDashboard from './HRMS/Dashboard/EmployeeDashboard';
import Users from './HRMS/Users/Users';
import Departments from './HRMS/Departments/Departments';
import Employee from './HRMS/Employee/Employee';
import UrlControl from './HRMS/Employee/UrlControl';
import MenuControl from './HRMS/Employee/MenuControl';
import SubMenuControl from './HRMS/Employee/SubMenuControl';
import RoleControl from './HRMS/Employee/RoleControl';
import RoleAccessControl from './HRMS/Employee/RoleAccessControl';
import EmployeeControl from './HRMS/Employee/EmployeeControl';
import EmployeeDetailControl from './HRMS/Employee/EmployeeDetailControl';
import ChangeProfileControl from './HRMS/Employee/ChangeProfile';
import EmployeeVerificationControl from './HRMS/Employee/EmployeeVerificationControl';
import FloorLeaveControl from './FloorLeaves/ListLeaves';
import FloorExitControl from './FloorExit/ListExit';
import FloorManagePayslipControl from './FloorManagePayslip/ListPayslip';
import FloorLeaveDetailControl from './FloorLeaves/LeaveDetails';
import FloorExitDetailControl from './FloorExit/ExitDetails';
import PayslipRequestControl from './FloorManagePayslip/PayslipRequest';
import PayslipDisplayControl from './HRMS/Employee/Payslipdisplay';
import FloorExchangeShiftControl from './FloorShift/ExchangeShift';
import FloorShiftControl from './FloorShift/InchargeDutyRoster';
import FloorShiftInfoControl from './FloorShift/InchargeShiftInfo';
import FloorManPowerControl from './FloorShift/InchargeManPower';
import DepartmentShiftInfoControl from './DepartmentShift/DeptShiftInfo';
import DepartmentManPowerControl from './DepartmentShift/HodManPower';
import DepartmentShiftControl from './DepartmentShift/HodDutyRoster';
import DeptManagePayslipControl from './DeptManagePayslip/DeptListPayslip';
import DeptPayslipRequestControl from './DeptManagePayslip/DeptPayslipRequest';
// import HrShiftInfoControl from './ShiftTimesheet/HrShiftInfo';
import HrShiftControl from './HrShift/HrDutyRoster';
import HrShiftInfoControl from './HrShift/HrShiftInfo';
import HrManPowerControl from './HrShift/HrManPower';
import HrManagePayslipControl from './HrManagePayslip/HrListPayslip';
import HrPayslipRequestControl from './HrManagePayslip/HrPayslipRequest';
import HrUpdateShiftInfoControl from './ShiftTimesheet/HrUpdateShiftInfo';
import HrImportAttendanceControl from './ShiftTimesheet/ImportAttendance';
import AttendanceLogControl from './HrShift/AttendanceLogList';
import DepartmentLeaveControl from './DeptLeaves/DeptListLeaves';
import DepartmentLeaveDetailControl from './DeptLeaves/DeptLeavesDetails';
import DepartmentExitControl from './DeptExit/DeptListExit';
import DepartmentExitDetailControl from './DeptExit/DeptExitDetails';
import HrLeaveControl from './HrLeaves/HrListLeaves';
import HrLeaveDetailControl from './HrLeaves/HrLeaveDetails';
import HrExitControl from './HrManageExit/HrListExit';
import HrExitDetailControl from './HrManageExit/HrExitDetails';
import TrainingAndAccomodation from './HRMS/Employee/TrainingAndAccomodation';
import MyshiftControl from './HRMS/Employee/MyshiftControl';
import AttendanceControl from './ShiftTimesheet/Attendance';
import AttendanceLeaveControl from './ShiftTimesheet/AttendanceLeave';
import AttendanceCalendarControl from './HRMS/Employee/AttendanceCalendarControl';
import DaywiseAttendanceControl from './ShiftTimesheet/ShiftwiseAttendance';
import UpdateAttendanceListControl from './ShiftTimesheet/UpdateAttendanceList';
import HrExchangeControl from './ShiftTimesheet/HrExchangeShift';
import ManageSalaryControl from './Payroll/ManageSalary';
import AdditionDeductionControl from './Payroll/AdditionandDeduction';
import ImportAllowanceControl from './Payroll/ImportAllowance';
import ImportDeductionControl from './Payroll/ImportDeduction';
import GenerateSalaryControl from './Payroll/GenerateSalary';
import SalaryApprovalControl from './Payroll/SalaryApproval';
import AccountVerificationControl from './Payroll/AccountVerification';
import CfoVerificationControl from './Payroll/CfoVerification';
import OfficeShiftControl from './ShiftTimesheet/OfficeShift';
import MysalaryControl from './HRMS/Employee/MysalaryControl';
import RequestPayslipControl from './HRMS/Employee/EmployeePayslipRequest';
import Permission from './HRMS/Employee/Permission';
import Leavecontrol from './HRMS/Employee/Leave';
import Add_department from './HRMS/Employee/Add_department';
import Floor from './HRMS/Employee/Floor';
import Holidays from './HRMS/Holidays/Holidays';
import Designation from './HRMS/Employee/Designation';
import Exit from './HRMS/Employee/Exit';
import Floorpermission from './Permission/Listpermission';
import Floorpermissiondetails from './Permission/Permission_details';
import Deptpermission from './Permission/Deptpermission';
import Hrpermission from './Permission/Hrpermission';
import Deptpermissiondetails from './Permission/Dept_permissiton_details';
import Hrpermissiondetails from './Permission/Hr_permission_details';
import Decument from './HRMS/Employee/Document';
import Qualification from './HRMS/Employee/Qualification';

import Events from './HRMS/Events/Events';
import Activities from './HRMS/Activities/Activities';
import Payroll from './HRMS/Payroll/Payroll';
import Report from './HRMS/Report/Report';
import Accounts from './HRMS/Accounts/Accounts';
import ProjectDashboard from './Project/Dashboard/Dashboard';
import ProjectList from './Project/ProjectList/Projectlist';
import Taskboard from './Project/Taskboard/Taskboard';
import TicketList from './Project/TicketList/TicketList';
import TicketDetails from './Project/TicketDetails/TicketDetails';
import Clients from './Project/Clients/Clients';
import TodoList from './Project/TodoList/TodoList';
import JobPortalDashboard from './JobPortal/Dashboard/Dashboard';
import Applicants from './JobPortal/Applicants/Applicants';
import Positions from './JobPortal/Positions/Positions';
import Resumes from './JobPortal/Resumes/Resumes';
import Settings from './JobPortal/Settings/Settings';
import Icons from './Icons/icons';
import IconsFeather from './Icons/IconsFeather';
import IconsLine from './Icons/IconsLine';
import IconsFlags from './Icons/IconsFlags';
import IconsPayments from './Icons/IconsPayments';
import Charts from './Charts/Charts';
import ChartsE from './Charts/ChartsE';
import ChartsC3 from './Charts/ChartsC3';
import ChartsKnob from './Charts/ChartsKnob';
import ChartsSparkline from './Charts/ChartsSparkline';
import Forms from './Forms/Forms';
import FormAdvanced from './Forms/FormAdvanced';
import FormValidation from './Forms/FormValidation';
import FormWizard from './Forms/FormWizard';
import FormSummernote from './Forms/FormSummernote';
import Tables from './Tables/Tables';
import DataTables from './Tables/DataTables';
import TablesColor from './Tables/TablesColor';
import TablesBasic from './Tables/TablesBasic';
import Widgets from './Widgets/Widgets';
import WCard from './Widgets/WCard';
import WStatistics from './Widgets/WStatistics';
import WData from './Widgets/WData';
import WSocial from './Widgets/WSocial';
import WOther from './Widgets/WOther';
import Search from './Search/Search';
import Profile from './Profile/Profile';
import AppCalendar from './AppPages/AppCalendar';
import AppContact from './AppPages/AppContact';
import AppChart from './AppPages/AppChart';
import AppFilemanager from './AppPages/AppFilemanager';
import AppSetting from './AppPages/AppSetting';
import Maps from './Maps/Maps';
import Gallery from './Gallery/Gallery';
import Login from './Authentication/login';
import Signup from './Authentication/signup';
import ForgotPassword from './Authentication/forgotpassword';
import NotFound from './Authentication/404';
import InternalServer from './Authentication/500';
import Overtime from './HRMS/Employee/Overtime';
import FloorOvertime from './Overtime/Incharge_ot';
import Floorotdetails from './Overtime/Inchargeotdetails';
import DeptOvertime from './Overtime/Dept_ot';
import deptotdetails from './Overtime/deptotdetails';
import Hrotdetails from './Overtime/Hrot';
import Hrotcalc from './Overtime/hrcalcot';


// job management 
import CreateJob from './JobListing/CreateJob';
import Permision from './Permision/Permission';
import OnboardingCandidates from './OnboardingCandidates/OnboardingCandidates';
import CreateCandidate from './Candidate/CreateCandidate';
import JobListing from './JobMentions/JobListing';
import Attendance_brief from './Reports/Attendance_brief';
import Attendance_summary from './Reports/Attendance_summary';
//overtime report
import Overtime_report from './Reports/Overtime';
import Leave_report from './Reports/Leave_report';
import Leave_available from './Reports/Leave_available';
import Employee_report from './Reports/Employee_report';
import Early_going_report from './Reports/Early_going';
import Weekly_going_report from './Reports/weekly_early_going_report';
import month_going_report from './Reports/monthly_early_going';
import Late_report from './Reports/Late_report';
import Weekly_late_report from './Reports/Weekly_late_report';
import Monthly_late_report from './Reports/Monthly_late_report';
import Pf_report from './Reports/Pf_report';
import Esi_report from './Reports/Esi_report';
import Pt_report from './Reports/Pt_report';
import monthly_overtime_report from './Reports/Monthly_overtime';
import Attendancehis_report from './Reports/Attendancehis_report';
import NoduedepartmentControl from './HRMS/Employee/NoDueDepartment';
import ExitprocedureControl from './ExitProcedure/ExitProcedure';
import NodueDeptControl from './ExitProcedure/NodueDeptupdate';
import NodueDeptWiseControl from './ExitProcedure/NodueDeptWise';
import NodueDeptWiseDetailControl from './ExitProcedure/NodueDeptWiseDetail';
import NodueStatusDetailControl from './ExitProcedure/NodueStatusDetail';
import NodueInterviewAnswersDetailControl from './ExitProcedure/NodueInterviewAnswersDetail';

//Asset Management
import Creates_asset from './Asset/Create_asset';
import Asset_list from './Asset/Asset_list';
import Asset_info from './Asset/AssetInfo';
import Catogory from './Asset/Catogory';
import Subcatogory from './Asset/Subcategory';
import Location from './Asset/Location';
import Suppliers from './Asset/Supplier';
import Assettype from './Asset/Assettype';
import manufacturers from './Asset/manufacturers';
import Assetreport from './Asset/Assetreport';
import workorder from './Asset/workorder';
import consolidated from './Asset/Workorder_Consolidated_report';
import myasset from './Asset/myasset';
import Asset_dashboard from './Asset/Asset_dashboard';
import TicketsList from './Asset/TicketsList';
import TicketView from './Asset/TicketView';
import ManageTickets from './Asset/ManageTickets';
import Mytask from './Asset/Mytask';
import Helpdeskticket from './Asset/Helpdeskticket';
import Helpdeskasset from './Asset/Helpdeskasset';
import Leads from './HRMS/Employee/Lead';

const Routes = [
    {
        path: "/dashboard",
        name: 'dashboard',
        exact: true,
        pageTitle: "HR Dashboard",
        component: Dashboard
    },

{
  path: "/Attendance-brief",
  name: "Attendance-brief",
  exact: true,
  pageTitle: "Job Listing",
  component: Attendance_brief
},
  

{
  path: "/Lead",
  name: "Lead",
  exact: true,
  pageTitle: "Lead",
  component: Leads
},
{
  path: "/Attendance-summary",
  name: "Attendance-summary",
  exact: true,
  pageTitle: "Attendance summary",
  component: Attendance_summary
},
{
  path: "/Helpdeskasset",
  name: "Helpdeskasset",
  exact: true,
  pageTitle: "Helpdeskasset",
  component: Helpdeskasset
},

{
  path: "/Create-asset",
  name: "Create-asset",
  exact: true,
  pageTitle: "Create-asset",
  component: Creates_asset
},

{
  path: "/ManageTickets",
  name: "ManageTickets",
  exact: true,
  pageTitle: "ManageTickets",
  component: ManageTickets
},

{
  path: "/Mytask",
  name: "Mytask",
  exact: true,
  pageTitle: "Mytask",
  component: Mytask
},

{
  path: "/TicketsList",
  name: "TicketsList",
  exact: true,
  pageTitle: "TicketsList",
  component: TicketsList
},

{
  path: "/ticket-view/:id",
  name: "ticket-view",
  exact: true,
  pageTitle: "ticket-view",
  component: TicketView
}
,

{
  path: "/Asset-list",
  name: "Asset-list",
  exact: true,
  pageTitle: "Asset-list",
  component: Asset_list
},


 {
  path: "/Helpdeskticket",
  name: "Helpdeskticket",
  exact: true,
  pageTitle: "Helpdeskticket",
  component: Helpdeskticket
},


{
  path: "/manufacturers",
  name: "manufacturers",
  exact: true,
  pageTitle: "manufacturers",
  component: manufacturers
},

{
  path: "/Asset_dashboard",
  name: "Asset_dashboard",
  exact: true,
  pageTitle: "Asset_dashboard",
  component: Asset_dashboard
},


 {
  path: "/workorder",
  name: "workorder",
  exact: true,
  pageTitle: "workorder",
  component: workorder
},

  {
  path: "/consolidated",
  name: "consolidated",
  exact: true,
  pageTitle: "consolidated",
  component: consolidated
},

{
  path: "/myasset",
  name: "myasset",
  exact: true,
  pageTitle: "myasset",
  component: myasset
},

{
  path: "/Assetreport",
  name: "Assetreport",
  exact: true,
  pageTitle: "Assetreport",
  component: Assetreport
},

{
  path: "/Catogory",
  name: "Catogory",
  exact: true,
  pageTitle: "Catogory",
  component: Catogory
},

{
  path: "/Assettype",
  name: "Assettype",
  exact: true,
  pageTitle: "Assettype",
  component: Assettype
},
{
  path: "/Suppliers",
  name: "Suppliers",
  exact: true,
  pageTitle: "Suppliers",
  component: Suppliers
},

{
  path: "/Location",
  name: "Location",
  exact: true,
  pageTitle: "Location",
  component: Location
},
{
  path: "/Subcatogory",
  name: "Subcatogory",
  exact: true,
  pageTitle: "Subcatogory",
  component: Subcatogory
},
{
  path: "/Asset-info/:id",
  name: "Asset-info",
  exact: true,
  pageTitle: "Asset-info",
  component: Asset_info
}
,
{
  path: "/Attendance-his",
  name: "Attendance-his",
  exact: true,
  pageTitle: "Attendance his",
  component: Attendancehis_report
},

{
  path: "/Weekly-going",
  name: "Weekly-going",
  exact: true,
  pageTitle: "Weekly-going",
  component: Weekly_going_report
},
{
  path: "/Early-going",
  name: "Early-going",
  exact: true,
  pageTitle: "Early-going",
  component: Early_going_report
},

{
  path: "/Late-report",
  name: "Late-report",
  exact: true,
  pageTitle: "Late-report",
  component: Late_report
},

{
  path: "/Weeklylate-report",
  name: "Weeklylate-report",
  exact: true,
  pageTitle: "Weeklylate-report",
  component: Weekly_late_report
},
{
  path: "/Pt-report",
  name: "Pt-report",
  exact: true,
  pageTitle: "Pt-report",
  component: Pt_report
},

{
  path: "/Monthlylate-report",
  name: "Monthlylate-report",
  exact: true,
  pageTitle: "Monthlylate-report",
  component: Monthly_late_report
},
{
  path: "/Monthly-going",
  name: "Monthly-going",
  exact: true,
  pageTitle: "Monthly-going",
  component: month_going_report
},
{
  path: "/Employee-Report",
  name: "Employee-Report",
  exact: true,
  pageTitle: "Employee-Report",
  component: Employee_report
},
{
  path: "/Leave-report",
  name: "Leave-report",
  exact: true,
  pageTitle: "Leave-report",
  component: Leave_report
},

{
  path: "/Monthly-overtime",
  name: "Monthly-overtime",
  exact: true,
  pageTitle: "Monthly-overtime",
  component: monthly_overtime_report
},
{
  path: "/Leave-available",
  name: "Leave-available",
  exact: true,
  pageTitle: "Leave-available",
  component: Leave_available
},
{
  path: "/Overtime-report",
  name: "Overtime-report",
  exact: true,
  pageTitle: "OVertime summary",
  component: Overtime_report
},

{
  path: "/Pf-report",
  name: "Pf-report",
  exact: true,
  pageTitle: "Pf-report",
  component: Pf_report
},
{
  path: "/Esi-report",
  name: "Esi-report",
  exact: true,
  pageTitle: "Esi-report",
  component: Esi_report
},
{
  path: "/job-listing",
  name: "job-listing",
  exact: true,
  pageTitle: "Job Listing",
  component: JobListing
},
   {
    path: "/job-permission",
    name: "job-permission",
    exact: true,
    pageTitle: "Permission Assignment",
    component: Permision
},
 {
        path: "/create-candidate",
        name: "createcandidate",
        exact: true,
        pageTitle: "Create Candidate",
        component: CreateCandidate
    },
     {
    path: "/onboarding-candidates",
    name: "onboarding-candidates",
    exact: true,
    pageTitle: "Onboarding Candidates",
    component: OnboardingCandidates
  },
  {
        path: "/create-job",
        name: "createjob",
        exact: true,
        pageTitle: "Create Job",
        component: CreateJob
    },
     {
        path: "/employee_dashboard",
        name: 'employee_dashboard',
        exact: true,
        pageTitle: "Employee Dashboard",
        component: EmployeeDashboard
    },
    {
        path: "/hr-users",
        name: 'hr-users',
        exact: true,
        pageTitle: "Users",
        component: Users
    },
    {
        path: "/hr-url",
        name: 'hr-url',
        exact: true,
        pageTitle: "Url",
        component: UrlControl
    },
    {
        path: "/hr-menu",
        name: 'hr-menu',
        exact: true,
        pageTitle: "Menu",
        component: MenuControl
    },
    {
        path: "/hr-submenu",
        name: 'hr-submenu',
        exact: true,
        pageTitle: "SubMenu",
        component: SubMenuControl
    },
    {
        path: "/hr-role",
        name: 'hr-role',
        exact: true,
        pageTitle: "Role",
        component: RoleControl
    },

    {
        path: "/hr-roleaccess",
        name: 'hr-roleaccess',
        exact: true,
        pageTitle: "RoleAccess",
        component: RoleAccessControl
    },
    {
        path: "/myshift",
        name: 'myshift',
        exact: true,
        pageTitle: "MyShift",
        component: MyshiftControl
    },
    {
            path: "/Import-Allowance",
            name: 'Import-Allowance',
            exact: true,
            pageTitle: "ImportAllowance",
            component: ImportAllowanceControl
    },
    {
            path: "/Import-Deduction",
            name: 'Import-Deduction',
            exact: true,
            pageTitle: "ImportDeduction",
            component: ImportDeductionControl
    },
    {
            path: "/Addallowance-deduction",
            name: 'Addallowance-deduction',
            exact: true,
            pageTitle: "AdditionDeduction",
            component: AdditionDeductionControl
    },
     {
            path: "/generate-salary",
            name: 'generate-salary',
            exact: true,
            pageTitle: "GenerateSalary",
            component: GenerateSalaryControl
    },
    {
            path: "/salary-approval",
            name: 'salary-approval',
            exact: true,
            pageTitle: "SalaryApproval",
            component: SalaryApprovalControl
    },
     {
            path: "/account-verification",
            name: 'account-verification',
            exact: true,
            pageTitle: "AccountVerification",
            component: AccountVerificationControl
    },
    {
            path: "/cfo-verification",
            name: 'cfo-verification',
            exact: true,
            pageTitle: "CfoVerification",
            component: CfoVerificationControl
    },
    {
            path: "/managesalary",
            name: 'managesalary',
            exact: true,
            pageTitle: "ManageSalary",
            component: ManageSalaryControl
    },
    {
            path: "/attendance",
            name: 'attendance',
            exact: true,
            pageTitle: "Attendance",
            component: AttendanceControl
    },
     {
            path: "/shiftwise-attendance",
            name: 'shiftwise-attendance',
            exact: true,
            pageTitle: "DaywiseAttendance",
            component: DaywiseAttendanceControl
    },
      {
            path: "/office-shift",
            name: 'office-shift',
            exact: true,
            pageTitle: "OfficeShift",
            component: OfficeShiftControl
    },
    
     {
            path: "/shift-exchanges",
            name: 'shift-exchanges',
            exact: true,
            pageTitle: "HrExchangeShift",
            component: HrExchangeControl
    },
    {
            path: "/updateattendancelist",
            name: 'updateattendancelist',
            exact: true,
            pageTitle: "UpdateAttendanceList",
            component: UpdateAttendanceListControl
    },
     {
            path: "/attendanceleave",
            name: 'attendanceleave',
            exact: true,
            pageTitle: "AttendanceLeave",
            component: AttendanceLeaveControl
    },
    {
        path: "/attendancecalendar",
        name: 'attendancecalendar',
        exact: true,
        pageTitle: "AttendanceCalendar",
        component: AttendanceCalendarControl
    },
    {
        path: "/mysalary",
        name: 'mysalary',
        exact: true,
        pageTitle: "MySalary",
        component: MysalaryControl
    },

    {
        path: "/employee-payslip",
        name: 'employee-payslip',
        exact: true,
        pageTitle: "RequestPayslipControlAccess",
        component: RequestPayslipControl
    },

    {
        path: "/permission",
        name: 'permission',
        exact: true,
        pageTitle: "Permission",
        component: Permission
    },
    {
        path: "/leave",
        name: 'leave',
        exact: true,
        pageTitle: "Leave",
        component: Leavecontrol
    },
    {
        path: "/hr-employees",
        name: 'hr-employees',
        exact: true,
        pageTitle: "EmployeeAccess",
        component: EmployeeControl
    },

    {
        path: "/employees-detail",
        name: 'employees-detail',
        exact: true,
        pageTitle: "EmployeeDetailAccess",
        component: EmployeeDetailControl
    },

    {
        path: "/change-profile",
        name: 'change-profile',
        exact: true,
        pageTitle: "ChangeProfileAccess",
        component: ChangeProfileControl
    },


    {
        path: "/hr-employeeverification",
        name: 'hr-employeeverification',
        exact: true,
        pageTitle: "EmployeeVerificationAccess",
        component: EmployeeVerificationControl
    },


    {
        path: "/Incharge-leaves",
        name: 'Incharge-leaves',
        exact: true,
        pageTitle: "FloorLeaveControlAccess",
        component: FloorLeaveControl
    },

    {
        path: "/Incharge-exit",
        name: 'Incharge-exit',
        exact: true,
        pageTitle: "FloorExitControlAccess",
        component: FloorExitControl
    },


    {
        path: "/Incharge-payslip",
        name: 'Incharge-payslip',
        exact: true,
        pageTitle: "FloorManagePayslipControlAccess",
        component: FloorManagePayslipControl
    },
     {
        path: "/Hr-shiftinfo",
        name: 'HR-shiftinfo',
        exact: true,
        pageTitle: "HrShiftInfoControlAccess",
        component: HrShiftInfoControl
    },


    {
        path: "/Incharge-shiftinfo",
        name: 'Incharge-shiftinfo',
        exact: true,
        pageTitle: "FloorShiftInfoControlAccess",
        component: FloorShiftInfoControl
    },

    {
        path: "/Floor-exchangeshift",
        name: 'Floor-exchangeshift',
        exact: true,
        pageTitle: "FloorExchangeShiftControlAccess",
        component: FloorExchangeShiftControl
    },

    {
        path: "/Incharge-dutyroster",
        name: 'Incharge-dutyroster',
        exact: true,
        pageTitle: "FloorShiftControlAccess",
        component: FloorShiftControl
    },
    {
        path: "/Incharge-manpower",
        name: 'Incharge-manpower',
        exact: true,
        pageTitle: "FloorManPowerControlAccess",
        component:  FloorManPowerControl

    },
    {
        path: "/Incharge-permission",
        name: 'Incharge-permission',
        exact: true,
        pageTitle: "Floorpermission",
        component: Floorpermission
    },
    {
        path: "/Hr-permission",
        name: 'Hr-permission',
        exact: true,
        pageTitle: "Hrpermission",
        component: Hrpermission
    },

    {
        path: "/Hr-manpower",
        name: 'Hr-manpower',
        exact: true,
        pageTitle: "HrManPowerControlAccess", 
        component:  HrManPowerControl

    },
    {
        path: "/Dept-permission",
        name: 'Dept-permission',
        exact: true,
        pageTitle: "Deptpermission",
        component: Deptpermission
    },
    {
        path: "/Dept-permission-details",
        name: 'Dept-permission-details',
        exact: true,
        pageTitle: "Deptpermissiondetails",
        component: Deptpermissiondetails
    },
    {
        path: "/Dept-shiftinfo",
        name: 'Dept-shiftinfo',
        exact: true,
        pageTitle: "DepartmentShiftInfoControlAccess",
        component: DepartmentShiftInfoControl
    },

    {
        path: "/Dept-payslip",
        name: 'Dept-payslip',
        exact: true,
        pageTitle: "DeptManagePayslipControlAccess",
        component: DeptManagePayslipControl
    },


    {
        path: "/deptpayslip-request",
        name: 'deptpayslip-request',
        exact: true,
        pageTitle: "DeptPayslipRequestControlAccess",
        component: DeptPayslipRequestControl
    },

     {
        path: "/payslipdisplay-request",
        name: 'payslipdisplay-request',
        exact: true,
        pageTitle: "PayslipDisplayControlAccess",
        component: PayslipDisplayControl
    },



    {
        path: "/Hod-manpower",
        name: 'Hod-manpower',
        exact: true,
        pageTitle: "DepartmentManPowerControlAccess",
        component:  DepartmentManPowerControl

    },
    {
        path: "/Hr-permission-details",
        name: 'Hr-permission-details',
        exact: true,
        pageTitle: "Hrpermissiondetails",
        component: Hrpermissiondetails
    },

    // {
    //     path: "/Hr-shiftinfo",
    //     name: 'Hr-shiftinfo',
    //     exact: true,
    //     pageTitle: "HrShiftInfoControlAccess",
    //     component: HrShiftInfoControl
    // },

    {
        path: "/Hr-payslip",
        name: 'Hr-payslip',
        exact: true,
        pageTitle: "HrManagePayslipControlAccess",
        component: HrManagePayslipControl
    },

    {
        path: "/hrpayslip-request",
        name: 'hrpayslip-request',
        exact: true,
        pageTitle: "HrPayslipRequestControlAccess",
        component: HrPayslipRequestControl
    },

    {
        path: "/Hr-updateshiftinfo",
        name: 'Hr-updateshiftinfo',
        exact: true,
        pageTitle: "HrUpdateShiftInfoControlAccess",
        component: HrUpdateShiftInfoControl
    },

    {
        path: "/import-attendance",
        name: 'import-attendance',
        exact: true,
        pageTitle: "HrImportAttendance",
        component: HrImportAttendanceControl
    },

  

    {
        path: "/Attendance-loglist",
        name: 'Attendance-loglist',
        exact: true,
        pageTitle: "AttendanceLogControlAccess",
        component: AttendanceLogControl
    },

    
    
    {
        path: "/floor-leave-details",
        name: 'floor-leave-details',
        exact: true,
        pageTitle: "FloorLeaveDetailControlAccess",
        component: FloorLeaveDetailControl
    },

     {
        path: "/floor-exit-details",
        name: 'floor-exit-details',
        exact: true,
        pageTitle: "FloorExitDetailControlAccess",
        component: FloorExitDetailControl
    },




    {
        path: "/payslip-request",
        name: 'payslip-request',
        exact: true,
        pageTitle: "PayslipRequestControlAccess",
        component: PayslipRequestControl
    },

    {
        path: "/floor-permission-details",
        name: 'floor-permission-details',
        exact: true,
        pageTitle: "Floorpermissiondetails",
        component: Floorpermissiondetails
    },
    {
        path: "/Dept-leaves",
        name: 'Dept-leaves',
        exact: true,
        pageTitle: "DeptLeaveControlAccess",
        component: DepartmentLeaveControl
    },
    {
        path: "/Dept-exit",
        name: 'Dept-exit',
        exact: true,
        pageTitle: "DeptExitControlAccess",
        component: DepartmentExitControl
    },


    {
        path: "/dept-leave-details",
        name: 'dept-leave-details',
        exact: true,
        pageTitle: "DepartmentLeaveDetailControlAccess",
        component: DepartmentLeaveDetailControl
    },

    {
        path: "/Hr-exit",
        name: 'Hr-exit',
        exact: true,
        pageTitle: "HrExitControlAccess",
        component: HrExitControl
    },


      {
        path: "/hr-exit-details",
        name: 'hr-exit-details',
        exact: true,
        pageTitle: "HrExitDetailControlAccess",
        component: HrExitDetailControl
    },


     {
        path: "/dept-exit-details",
        name: 'dept-exit-details',
        exact: true,
        pageTitle: "DepartmentExitDetailControlAccess",
        component: DepartmentExitDetailControl
    },

  

    {
        path: "/Hod-dutyroster",
        name: 'Hod-dutyroster',
        exact: true,
        pageTitle: "DepartmentShiftControlAccess",
        component: DepartmentShiftControl
    },

    {
        path: "/Hr-leave",
        name: 'Hr-leave',
        exact: true,
        pageTitle: "HrLeaveControlAccess",
        component: HrLeaveControl
    },

    {
        path: "/hr-leave-details",
        name: 'hr-leave-details',
        exact: true,
        pageTitle: "HrLeaveDetailControlAccess",
        component: HrLeaveDetailControl
    },

    {
        path: "/Hr-dutyroster",
        name: 'Hr-dutyroster',
        exact: true,
        pageTitle: "HrShiftControlAccess",
        component: HrShiftControl
    },



    {
        path: "/hr-trainingaccomodation",
        name: 'hr-trainingaccomodation',
        exact: true,
        pageTitle: "TrainingAccomodationAccess",
        component: TrainingAndAccomodation
    },

    {
        path: "/hr-department",
        name: 'department',
        exact: true,
        pageTitle: "Departments",
        component: Departments
    },
    {
        path: "/hr-employee",
        name: 'employee',
        exact: true,
        pageTitle: "Employee",
        component: Employee
    },
    {
        path: "/hr-activities",
        name: 'activities',
        exact: true,
        pageTitle: "Activities",
        component: Activities
    },
    {
        path: "/hr-holidays",
        name: 'holidays',
        exact: true,
        pageTitle: "Holidays",
        component: Holidays
    },
    {
        path: "/hr-events",
        name: 'events',
        exact: true,
        pageTitle: "Events",
        component: Events
    },
    {
        path: "/hr-payroll",
        name: 'payroll',
        exact: true,
        pageTitle: "Payroll",
        component: Payroll
    },
    {
        path: "/hr-accounts",
        name: 'accounts',
        exact: true,
        pageTitle: "Accounts",
        component: Accounts
    },
    {
        path: "/hr-report",
        name: 'report',
        exact: true,
        pageTitle: "Report",
        component: Report
    },
    // add new routes here

    //project

    {
        path: "/project-dashboard",
        name: 'projectDashboard',
        exact: true,
        pageTitle: "'Project Dashboard",
        component: ProjectDashboard
    },
    {
        path: "/project-list",
        name: 'project-list',
        exact: true,
        pageTitle: "Project",
        component: ProjectList
    },

    {
        path: "/project-taskboard",
        name: 'project-taskboard',
        exact: true,
        pageTitle: "Taskboard",
        component: Taskboard
    },

    {
        path: "/project-ticket",
        name: 'project-ticket',
        exact: true,
        pageTitle: "Ticket List",
        component: TicketList
    },

    {
        path: "/project-ticket-details",
        name: 'project-ticket-details',
        exact: true,
        pageTitle: "Ticket Details",
        component: TicketDetails
    },
    {
        path: "/project-clients",
        name: 'project-clients',
        exact: true,
        pageTitle: "Clients",
        component: Clients
    },

    {
        path: "/project-todo",
        name: 'project-todo',
        exact: true,
        pageTitle: "Todo List",
        component: TodoList
    },

    //job portal

    {
        path: "/jobportal-dashboard",
        name: 'jobportalDashboard',
        exact: true,
        pageTitle: "Job Dashboard",
        component: JobPortalDashboard
    },
    {
        path: "/jobportal-positions",
        name: 'jobportalPositions',
        exact: true,
        pageTitle: "Job Positions",
        component: Positions
    },
    {
        path: "/jobportal-applicants",
        name: 'jobportalpplicants',
        exact: true,
        pageTitle: "Job Applicants",
        component: Applicants
    },
    {
        path: "/jobportal-resumes",
        name: 'jobportalResumes',
        exact: true,
        pageTitle: "Job Resumes",
        component: Resumes
    },
    {
        path: "/jobportal-settings",
        name: 'jobportalSettings',
        exact: true,
        pageTitle: "Job Settings",
        component: Settings
    },


    {
        path: "/login",
        name: 'login',
        exact: true,
        pageTitle: "Tables",
        component: Login
    },
    {
        path: "/signup",
        name: 'signup',
        exact: true,
        pageTitle: "Tables",
        component: Signup
    },
    {
        path: "/forgotpassword",
        name: 'forgotpassword',
        exact: true,
        pageTitle: "Tables",
        component: ForgotPassword
    },
    {
        path: "/notfound",
        name: 'notfound',
        exact: true,
        pageTitle: "Tables",
        component: NotFound
    },
    {
        path: "/internalserver",
        name: 'internalserver',
        exact: true,
        pageTitle: "Tables",
        component: InternalServer
    },
    {
        path: "/icons",
        name: 'icons',
        exact: true,
        pageTitle: "Icons",
        component: Icons
    },
    {
        path: "/icons-feather",
        name: 'icons-feather',
        exact: true,
        pageTitle: "Icons",
        component: IconsFeather
    },
    {
        path: "/icons-line",
        name: 'icons-line',
        exact: true,
        pageTitle: "Icons",
        component: IconsLine
    },
    {
        path: "/icons-flag",
        name: 'icons-flag',
        exact: true,
        pageTitle: "Icons",
        component: IconsFlags
    },
    {
        path: "/icons-payments",
        name: 'icons-payments',
        exact: true,
        pageTitle: "Icons",
        component: IconsPayments
    },
    {
        path: "/charts",
        name: 'charts',
        exact: true,
        pageTitle: "Charts",
        component: Charts
    },
    {
        path: "/charts-e",
        name: 'charts-e',
        exact: true,
        pageTitle: "Charts",
        component: ChartsE
    },
    {
        path: "/charts-c3",
        name: 'charts-c3',
        exact: true,
        pageTitle: "Charts",
        component: ChartsC3
    },
    {
        path: "/charts-knob",
        name: 'charts-knob',
        exact: true,
        pageTitle: "Charts",
        component: ChartsKnob
    },
    {
        path: "/charts-sparkline",
        name: 'charts-sparkline',
        exact: true,
        pageTitle: "Charts",
        component: ChartsSparkline
    },

    {
        path: "/forms",
        name: 'forms',
        exact: true,
        pageTitle: "Forms Elements",
        component: Forms
    },
    {
        path: "/form-advanced",
        name: 'form-advanced',
        exact: true,
        pageTitle: "Forms Elements",
        component: FormAdvanced
    },
    {
        path: "/form-validation",
        name: 'form-validation',
        exact: true,
        pageTitle: "Forms Elements",
        component: FormValidation
    },
    {
        path: "/form-wizard",
        name: 'form-wizard',
        exact: true,
        pageTitle: "Forms Elements",
        component: FormWizard
    },
    {
        path: "/form-summernote",
        name: 'form-summernote',
        exact: true,
        pageTitle: "Forms Elements",
        component: FormSummernote
    },

    {
        path: "/tables",
        name: 'tables',
        exact: true,
        pageTitle: "Tables",
        component: Tables
    },
    {
        path: "/tables-datatable",
        name: 'tables-datatable',
        exact: true,
        pageTitle: "Tables",
        component: DataTables
    },
    {
        path: "/tables-color",
        name: 'tables-color',
        exact: true,
        pageTitle: "Tables",
        component: TablesColor
    },
    {
        path: "/tables-basic",
        name: 'tables-basic',
        exact: true,
        pageTitle: "Tables",
        component: TablesBasic
    },

    {
        path: "/widgets",
        name: 'widgets',
        exact: true,
        pageTitle: "Widgets",
        component: Widgets
    },
    {
        path: "/w-card",
        name: 'w-card',
        exact: true,
        pageTitle: "Widgets",
        component: WCard
    },
    {
        path: "/w-statistics",
        name: 'w-statistics',
        exact: true,
        pageTitle: "Widgets",
        component: WStatistics
    },
    {
        path: "/w-data",
        name: 'w-data',
        exact: true,
        pageTitle: "Widgets",
        component: WData
    },
    {
        path: "/w-social",
        name: 'w-social',
        exact: true,
        pageTitle: "Widgets",
        component: WSocial
    },
    {
        path: "/w-other",
        name: 'w-other',
        exact: true,
        pageTitle: "Widgets",
        component: WOther
    },
    {
        path: "/page-search",
        name: 'page-search',
        exact: true,
        pageTitle: "Search",
        component: Search
    },
    {
        path: "/app-calendar",
        name: 'app-calendar',
        exact: true,
        pageTitle: "Calendar",
        component: AppCalendar
    },
    {
        path: "/app-contact",
        name: 'app-contact',
        exact: true,
        pageTitle: "Contact",
        component: AppContact
    },
    {
        path: "/app-chat",
        name: 'app-chat',
        exact: true,
        pageTitle: "Friends Group",
        component: AppChart
    },
    {
        path: "/app-filemanager",
        name: 'app-filemanager',
        exact: true,
        pageTitle: "File Manager",
        component: AppFilemanager
    },
    {
        path: "/app-setting",
        name: 'app-setting',
        exact: true,
        pageTitle: "App Setting",
        component: AppSetting
    },
    {
        path: "/profile",
        name: 'profile',
        exact: true,
        pageTitle: "My Profile",
        component: Profile
    },
    {
        path: "/maps",
        name: 'maps',
        exact: true,
        pageTitle: "Vector Maps",
        component: Maps
    },
    {
        path: "/gallery",
        name: 'gallery',
        exact: true,
        pageTitle: "Image Gallery",
        component: Gallery
    },


    {
        path: "/Add_department",
        name: 'Add_department',
        exact: true,
        pageTitle: "Department",
        component: Add_department
    },
    {
        path: "/Noduedepartment",
        name: 'Noduedepartment',
        exact: true,
        pageTitle: "Noduedepartment",
        component: NoduedepartmentControl
    },
    {
        path: "/exitprocedure",
        name: 'exitprocedure',
        exact: true,
        pageTitle: "ExitProcedure",
        component: ExitprocedureControl
    },
     {
        path: "/Nodue-deptupdate",
        name: 'Nodue-deptupdate',
        exact: true,
        pageTitle: "NodueDeptupdate",
        component: NodueDeptControl
    },

     {
        path: "/Nodue-DeptWise",
        name: 'Nodue-DeptWise',
        exact: true,
        pageTitle: "NodueDeptWiseControl",
        component: NodueDeptWiseControl
    },

    {
        path: "/nodue-dept-wise-detail",
        name: 'nodue-dept-wise-detail',
        exact: true,
        pageTitle: "NodueDeptWiseDetailControl",
        component: NodueDeptWiseDetailControl
    },

     {
        path: "/Nodue-StatusDetail",
        name: 'Nodue-StatusDetail',
        exact: true,
        pageTitle: "NodueStatusDetailControl",
        component: NodueStatusDetailControl
    },
    {
        path: "/Nodue-InterviewAnswersDetail",
        name: 'Nodue-InterviewAnswersDetail',
        exact: true,
        pageTitle: "NodueInterviewAnswersDetailControl",
        component: NodueInterviewAnswersDetailControl
    },
    {
        path: "/Floor",
        name: 'Floor',
        exact: true,
        pageTitle: "Floor",
        component: Floor
    },
    {
        path: "/Designation",
        name: 'Designation',
        exact: true,
        pageTitle: "Designation",
        component: Designation
    },
    {
        path: "/Decument",
        name: 'Decument',
        exact: true,
        pageTitle: "Decument",
        component: Decument
    },

    {
        path: "/Qualification",
        name: 'Qualification',
        exact: true,
        pageTitle: "Qualification",
        component: Qualification
    },
    {
        path: "/Exit",
        name: 'Exit',
        exact: true,
        pageTitle: "Exit",
        component: Exit
    },
    {
        path: "/Overtime",
        name: 'Overtime',
        exact: true,
        pageTitle: "Overtime",
        component: Overtime
    },
     {
        path: "/Incharge-ot",
        name: 'Incharge-ot',
        exact: true,
        pageTitle: "FloorLeaveControlAccess",
        component: FloorOvertime
    },
    {
        path: "/Inchargeotdetails",
        name: 'Inchargeotdetails',
        exact: true,
        pageTitle: "FloorLeaveDetailControlAccess",
        component: Floorotdetails
    },
    {
        path: "/Dept-ot",
        name: 'Dept-ot',
        exact: true,
        pageTitle: "FloorLeaveControlAccess",
        component: DeptOvertime
    },
    {
        path: "/deptotdetails",
        name: 'deptotdetails',
        exact: true,
        pageTitle: "FloorLeaveDetailControlAccess",
        component: deptotdetails
    },

     {
        path: "/hrot",
        name: 'hrot',
        exact: true,
        pageTitle: "Hrotdetails",
        component: Hrotdetails
    },

    {
        path: "/hrcalcot",
        name: 'hrcalcot',
        exact: true,
        pageTitle: "FloorLeaveDetailControlAccess",
        component: Hrotcalc
    },
];

export default Routes;